import * as yup from 'yup'

export const schemaData = yup.object().shape({
  description: yup.string().required(),
  price: yup
    .number()
    .required()
    .moreThan(0),
})

export default schemaData
